import templateUrl from "webforms/formio/formio-details.htm";
import controller from "webforms/formio/formio-details.controller";
import "webforms/formio/formio-details.scss";
import "webforms/formio/formio-details.client.scss";

export default {
  bindings: {
    formioId: "<",
    mode: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
